import { buildApiUrl } from "../runtimeConfig";

let cachedToken: string | null = null;
const DEFAULT_TOKEN_TIMEOUT_MS = 8000;

export const clearAntiforgeryToken = () => {
  cachedToken = null;
};

export const getAntiforgeryToken = async (timeoutMs: number = DEFAULT_TOKEN_TIMEOUT_MS): Promise<string> => {
  if (cachedToken) {
    return cachedToken;
  }

  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    const response = await fetch(buildApiUrl("/api/security/antiforgery-token"), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
      signal: controller.signal,
    });

    if (!response.ok) {
      if (response.status === 401) {
        window.dispatchEvent(new CustomEvent("moneylights:auth-expired"));
      }
      throw new Error("Unable to fetch security token.");
    }

    const data = await response.json() as { token?: string };
    if (!data.token) {
      throw new Error("Security token is missing.");
    }

    cachedToken = data.token;
    return cachedToken;
  } finally {
    window.clearTimeout(timeoutId);
  }
};
